import DemandPlannerActions from "../actions/demandPlannerActions";

const DemandPlannerReducer = (
  state = {
    isDemandPlannerLoading: false, demandPlannerHasError: false,
    isDemandPlannerSecMatLoading: false, demandPlannerSecMatHasError: false,
    isDemandPlannerSecMatSaleMskuLoading: false, demandPlannerSecMatHasSaleMskuError: false,
    isDemandPlannerSecYoyLoading: false, demandPlannerSecYoyHasError: false,
    isDemandPlannerPriMatLoading: false, demandPlannerPriMatHasError: false,
    isDemandPlannerPriMatSaleMskuLoading: false, demandPlannerPriMatHasSaleMskuError: false,
    isDemandPlannerPriYoyLoading: false, demandPlannerPriYoyHasError: false,    
    isDemandPlannerDifferencesLoading: false, demandPlannerDifferencesHasError: false,
    isEnumGregWeeksLoading: false, enumGregWeeksHasError: false,
  },
  action
) => {
  switch (action.type) {
    case DemandPlannerActions.DEMAND_PLANNER_REQUEST:
      return {
        ...state,
        isDemandPlannerLoading: true,
        demandPlannerHasError: false,
        demandPlanner: null
      };
    case DemandPlannerActions.DEMAND_PLANNER_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerLoading: false,
        demandPlanner: action.data,
        demandPlannerHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerLoading: false,
        demandPlannerHasError: true,
        demandPlanner: []
      };


    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_REQUEST:
      return {
        ...state,
        isDemandPlannerSecMatLoading: true,
        demandPlannerSecMatHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerSecMatLoading: false,
        demandPlannerSecMat: action.data,
        demandPlannerSecMatHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerSecMatLoading: false,
        demandPlannerSecMatHasError: true,
        demandPlannerSecMat: []
      };


    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_SALE_MSKU_REQUEST:
      return {
        ...state,
        isDemandPlannerSecMatSaleMskuLoading: true,
        demandPlannerSecMatHasSaleMskuError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_SALE_MSKU_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerSecMatSaleMskuLoading: false,
        demandPlannerSecMatSaleMsku: action.data,
        demandPlannerSecMatHasSaleMskuError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_SALE_MSKU_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerSecMatSaleMskuLoading: false,
        demandPlannerSecMatHasSaleMskuError: true,
        demandPlannerSecMatSaleMsku: []
      };


    case DemandPlannerActions.DEMAND_PLANNER_SEC_YOY_REQUEST:
      return {
        ...state,
        isDemandPlannerSecYoyLoading: true,
        demandPlannerSecYoyHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_YOY_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerSecYoyLoading: false,
        demandPlannerSecYoy: action.data,
        demandPlannerSecYoyHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_YOY_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerSecYoyLoading: false,
        demandPlannerSecYoyHasError: true,
        demandPlannerSecYoy: null
      };


    case DemandPlannerActions.DEMAND_PLANNER_PRI_MAT_REQUEST:
      return {
        ...state,
        isDemandPlannerPriMatLoading: true,
        demandPlannerPriMatHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_PRI_MAT_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerPriMatLoading: false,
        demandPlannerPriMat: action.data,
        demandPlannerPriMatHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_PRI_MAT_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerPriMatLoading: false,
        demandPlannerPriMatHasError: true,
        demandPlannerPriMat: []
      };


    case DemandPlannerActions.DEMAND_PLANNER_PRI_MAT_SALE_MSKU_REQUEST:
      return {
        ...state,
        isDemandPlannerPriMatSaleMskuLoading: true,
        demandPlannerPriMatHasSaleMskuError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_PRI_MAT_SALE_MSKU_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerPriMatSaleMskuLoading: false,
        demandPlannerPriMatSaleMsku: action.data,
        demandPlannerPriMatHasSaleMskuError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_PRI_MAT_SALE_MSKU_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerPriMatSaleMskuLoading: false,
        demandPlannerPriMatHasSaleMskuError: true,
        demandPlannerPriMatSaleMsku: []
      };


    case DemandPlannerActions.DEMAND_PLANNER_PRI_YOY_REQUEST:
      return {
        ...state,
        isDemandPlannerPriYoyLoading: true,
        demandPlannerPriYoyHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_PRI_YOY_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerPriYoyLoading: false,
        demandPlannerPriYoy: action.data,
        demandPlannerPriYoyHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_PRI_YOY_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerPriYoyLoading: false,
        demandPlannerPriYoyHasError: true,
        demandPlannerPriYoy: null
      };


    case DemandPlannerActions.DEMAND_PLANNER_DIFFERENCES_REQUEST:
      return {
        ...state,
        isDemandPlannerDifferencesLoading: true,
        demandPlannerDifferences: null,
        demandPlannerDifferencesHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_DIFFERENCES_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerDifferencesLoading: false,
        demandPlannerDifferences: action.data,
        demandPlannerDifferencesHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_DIFFERENCES_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerDifferencesLoading: false,
        demandPlannerDifferencesHasError: true,
        demandPlannerDifferences: null
      };


      case DemandPlannerActions.ENUM_GREG_WEEKS_REQUEST:
        return {
          ...state,
          isEnumGregWeeksLoading: true,
          enumGregWeeks: null,
          enumGregWeeksHasError: false
        };
      case DemandPlannerActions.ENUM_GREG_WEEKS_SUCCESSFUL:
        return {
          ...state,
          isEnumGregWeeksLoading: false,
          enumGregWeeks: action.data,
          enumGregWeeksHasError: false
        };
      case DemandPlannerActions.ENUM_GREG_WEEKS_FAILED:
        return {
          ...state,
          errorMessage: {},
          isEnumGregWeeksLoading: false,
          enumGregWeeksHasError: true,
          enumGregWeeks: null
        };
    default:
      return {
        ...state
      };
    //   break;
  }
};

export default DemandPlannerReducer;
